import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { DEFAULT_LANGUAGE, getLanguageLocale } from '@/features/language/config';
import { readLanguagePreference } from '@/features/language/preference';
import { registerShellVersionSync, syncShellBundleVersion } from '@/config/versionSync';
import './index.css';

const applyInitialTheme = () => {
  const stored = window.localStorage.getItem('shell-theme');
  const initialTheme = stored === 'light' || stored === 'dark' ? stored : 'dark';
  document.documentElement.setAttribute('data-theme', initialTheme);
};

const applyInitialLanguage = () => {
  const initialLanguage = readLanguagePreference() ?? DEFAULT_LANGUAGE;
  document.documentElement.setAttribute('lang', getLanguageLocale(initialLanguage));
};

// Initialize the application
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

applyInitialTheme();
applyInitialLanguage();

const bootstrap = async () => {
  const isReloadingForFreshBundle = await syncShellBundleVersion();
  if (isReloadingForFreshBundle) {
    return;
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );

  registerShellVersionSync();
};

void bootstrap();
